import posthog from 'posthog-js';

export enum FeatureFlag {
  AiChatEnabled = 'gxgo-ai-chat-enabled',
  AiPromptShareEnabled = 'gxgo-ai-prompt-share-enabled',
  MaintenanceModeEnabled = 'gxgo-maintenance-mode-enabled',
  PersonalizationEnabled = 'gxgo-personalization-enabled',
  ExportVideoExplainer = 'gxgo-export-video-explainer',
  HubspotPageviewEventsEnabled = 'gxgo-hubspot-pageview-events-enabled',
  MonthlyRecapModal = 'gxgo-monthly-recap-modal-enabled',
  DataSciencePrototypesEnabled = 'gxgo-data-science-prototypes-enabled',
  // TODO(fuzzy-search-tuning): remove this flag once tuning params are finalized
  CatalogFuzzySearchSettings = 'gxgo-catalog-fuzzy-search-settings'
}
export type FlagKey = FeatureFlag;

export type FeatureFlagPayloadMap = {
  [FeatureFlag.HubspotPageviewEventsEnabled]: { filters?: unknown };
};

export type PayloadFlagKey = keyof FeatureFlagPayloadMap;

export function isEnabled<K extends FlagKey>(key: K): boolean {
  return Boolean(posthog.isFeatureEnabled(key));
}

export function getPayload<K extends PayloadFlagKey>(key: K): FeatureFlagPayloadMap[K] | undefined {
  return posthog.getFeatureFlagResult(key) as FeatureFlagPayloadMap[K] | undefined;
}

export function reload(): void {
  posthog.reloadFeatureFlags();
}
